<script setup lang="ts">
import { computed } from 'vue';
import { RouterView } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ElConfigProvider } from 'element-plus';
import en from 'element-plus/es/locale/lang/en';
import ru from 'element-plus/es/locale/lang/ru';

defineOptions({
  name: 'App',
});

const { locale } = useI18n();
const ruLocale = {
  ...ru,
  el: {
    ...ru.el,
    pagination: {
      ...ru.el.pagination,
      pagesize: '',
    },
  },
};
const enLocale = {
  ...en,
  el: {
    ...en.el,
    pagination: {
      ...en.el.pagination,
      pagesize: '',
    },
  },
};
const elementLocale = computed(() => (locale.value === 'ru' ? ruLocale : enLocale));
</script>

<template>
  <ElConfigProvider :locale="elementLocale">
    <RouterView />
  </ElConfigProvider>
</template>

<style>
/* Global styles - unscoped for html/body */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

/* frontend-class-mappings-R02: navigation and teleported header menus share the UI font. */
body {
  font-family: var(--el-font-family);
}

#app {
  height: 100%;
}
</style>
